import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../firebase.js';
import { collection, getDocs, orderBy, query, where } from "@firebase/firestore"; 
import { useNavigate } from 'react-router-dom';
import defaulProfPic from '../Images/defprofile.png';
import { Timestamp } from '@firebase/firestore';

function StudentsGraduatingComp() {
  const db = getFirestore(app);
  const navigate = useNavigate();

  const [studentsList, setStudentList] = useState([]);
  const [countAllData, setcountAllData] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const courseSnap = await getDocs(query(collection(db, 'courses'), orderBy("rank")));
      const courseDurationMap = {};
      courseSnap.forEach((doc) => {
        const data = doc.data();
        const courseName = data.mcourseName;
        const duration = data.courseDuration ?? data.mcourseDuration;
        const parsed = parseInt(duration, 10);
        if (courseName && parsed && !Number.isNaN(parsed)) {
          courseDurationMap[courseName] = parsed;
        }
      });

      const usersSnap = await getDocs(query(collection(db, 'users'), orderBy("appDate", 'desc'), where("userStatus", "==", "Student")));
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();
      const nextMonthDate = new Date(currentYear, currentMonth + 1, 1);
      const nextMonth = nextMonthDate.getMonth();
      const nextYear = nextMonthDate.getFullYear();

      const studentsItem = [];
      usersSnap.forEach((doc) => {
        const data = doc.data();
        const admissionDateRaw = data.admissionDate;
        if (!admissionDateRaw) return;

        const courseName = data.course;
        const durationMonths = courseDurationMap[courseName];
        if (!durationMonths) return;

        let admissionDate;
        if (admissionDateRaw instanceof Timestamp) {
          admissionDate = admissionDateRaw.toDate();
        } else if (admissionDateRaw?.seconds) {
          admissionDate = new Date(admissionDateRaw.seconds * 1000);
        } else {
          admissionDate = new Date(admissionDateRaw);
        }
        if (Number.isNaN(admissionDate.getTime())) return;

        const graduationDate = new Date(admissionDate);
        graduationDate.setMonth(graduationDate.getMonth() + durationMonths);

        const gradMonth = graduationDate.getMonth();
        const gradYear = graduationDate.getFullYear();

        const isThisMonth = gradMonth === currentMonth && gradYear === currentYear;
        const isNextMonth = gradMonth === nextMonth && gradYear === nextYear;

        if (isThisMonth || isNextMonth) {
          studentsItem.push({
            id: doc.id,
            ...data,
            admissionDate,
            graduationDate,
            gradBucket: isThisMonth ? 'This Month' : 'Next Month',
            durationMonths
          });
        }
      });

      setStudentList(studentsItem);
      setcountAllData(studentsItem.length);
    };

    fetchData();
  }, [db]);

  const formatDate = (dateValue) => {
    if (!dateValue) return 'N/A';
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    if (Number.isNaN(date.getTime())) return 'N/A';
    return date.toDateString();
  };

  const formatDurationMonths = (months) => {
    if (!months || Number.isNaN(parseInt(months, 10))) return 'N/A';
    const value = parseInt(months, 10);
    return `${value} month${value === 1 ? '' : 's'}`;
  };

  const calculateTimeAsStudent = (admissionDateValue) => {
    if (!admissionDateValue) return 'N/A';
    const start = admissionDateValue instanceof Date ? admissionDateValue : new Date(admissionDateValue);
    if (Number.isNaN(start.getTime())) return 'N/A';
    const now = new Date();
    let months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
    if (now.getDate() < start.getDate()) {
      months -= 1;
    }
    if (months < 0) months = 0;
    return `${months} month${months === 1 ? '' : 's'}`;
  };

  function viewStudent(userId) {
    navigate('/view-student', { state: { myData: userId } });
  }

  const thisMonthCount = studentsList.filter((student) => student.gradBucket === 'This Month').length;
  const nextMonthCount = studentsList.filter((student) => student.gradBucket === 'Next Month').length;

  return (
    <div className="clientsComp applicationsPage">
      <div className="appsHeader">
        <div>
          <p className="appsKicker">Students</p>
          <h4>Students Graduating</h4>
          <p className="appsSubtext">Expected to graduate this month and next month.</p>
        </div>
        <div className="appsHeaderStats">
          <div className="appsStatChip">
            <span>Total</span>
            <strong>{countAllData}</strong>
          </div>
          <div className="appsStatChip">
            <span>This Month</span>
            <strong>{thisMonthCount}</strong>
          </div>
          <div className="appsStatChip">
            <span>Next Month</span>
            <strong>{nextMonthCount}</strong>
          </div>
        </div>
      </div>

      <div className="appsTableCard">
        <div className="appsTableHeader">
          <h6>Graduating Soon</h6>
          <span>{studentsList.length} results</span>
        </div>
        <div className="appsTableWrap">
          <Table hover responsive className="appsTable">
            <thead>
              <tr>
                <th>Student</th>
                <th>Course</th>
                <th>Admission Date</th>
                <th>Graduation Date</th>
                <th>Graduating</th>
                <th>Course Duration</th>
                <th>Time as Student</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {studentsList.map((student) => (
                <tr key={student.id}>
                  <td>
                    <div className="appsStudentCell">
                      <div className='appDefProfPic'>
                        <img src={student.profilePic ? student.profilePic : defaulProfPic} alt="profile" />
                      </div>
                      <div>
                        <p className="appsStudentName">{student.bio || 'Unnamed student'}</p>
                        <span className="appsStudentMeta">{student.course || 'Course not set'}</span>
                      </div>
                    </div>
                  </td>
                  <td>{student.course || '—'}</td>
                  <td>{formatDate(student.admissionDate)}</td>
                  <td>{formatDate(student.graduationDate)}</td>
                  <td>{student.gradBucket || '—'}</td>
                  <td>{formatDurationMonths(student.durationMonths)}</td>
                  <td>{calculateTimeAsStudent(student.admissionDate)}</td>
                  <td>
                    <button className='appsViewBtn' onClick={() => viewStudent(student.userId)}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
              {studentsList.length === 0 && (
                <tr>
                  <td colSpan="8" className="appsEmptyState">
                    No students graduating in the next two months.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default StudentsGraduatingComp;
